import React, { useState } from "react";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import classes from "./index.module.scss";

const innerTheme = createTheme({ palette: { mode: "dark" } });

export type SubmitLogin = {
  e: React.FormEvent;
  email: string;
  password: string;
};

type LoginFormProps = {
  title: string;
  subtitle: string;
  handleSubmit: (props: SubmitLogin) => void;
  loading: boolean;
  error: string;
};

const LoginForm = (props: LoginFormProps) => {
  const { title, subtitle, handleSubmit, error, loading } = props;

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  return (
    <div className={classes.container}>
      <span>
        <p className={classes.welcomeText}>{title}</p>
        <p className={classes.loginText}>{subtitle}</p>
      </span>

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={innerTheme}>
          <div className={classes.inputContainer}>
            <form
              style={{ display: "flex", flexDirection: "column", width: "90%" }}
              onSubmit={(e) => handleSubmit({ e, email, password })}
            >
              <TextField
                id="email"
                label="Email"
                type="email"
                required
                fullWidth
                style={{ margin: "5% 0" }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                id="password"
                label="Password"
                type="password"
                required
                fullWidth
                style={{ marginBottom: "5%" }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error && <p className={classes.errorMessage}>{error}</p>}

              <Button
                style={{
                  width: 100,
                  background: "rgba(0,0,0,0)",
                  color: "rgba(255, 255, 255, 0.7)",
                }}
                type="submit"
                variant="contained"
              >
                {loading ? <CircularProgress size="20px" /> : "Login"}
              </Button>
            </form>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
};

export default LoginForm;
